import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreStorageNgrxModule } from '@dges/modules/storage/store/ngrx';
import { StoreSkillsFirebaseModule } from '@dges/modules/portfolio/store/ngrx';
import { StoreToolsFirebaseModule } from '@dges/modules/portfolio/store/ngrx';
import { StoreJobsFirebaseModule } from '@dges/modules/portfolio/store/ngrx';
import { StoreEducationFirebaseModule } from '@dges/modules/portfolio/store/ngrx';
import { StoreProjectsFirebaseModule } from '@dges/modules/portfolio/store/ngrx';
import { StoreCompaniesFirebaseModule } from '@dges/modules/portfolio/store/ngrx';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreStorageNgrxModule,
    StoreSkillsFirebaseModule,
    StoreToolsFirebaseModule,
    StoreJobsFirebaseModule,
    StoreProjectsFirebaseModule,
    StoreEducationFirebaseModule,
    StoreCompaniesFirebaseModule,
    StoreModule.forRoot(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      },
    ),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ connectInZone: true }),
  ],
})
export class RootStoreModule {}
